import React, { useState } from 'react';
import {
  TextField, Button, Paper, Typography, Box, Snackbar, Alert, MenuItem
} from '@mui/material';
import { createNewUser } from '../../../../services/Users';

const CreateUserForm = ({ onSuccess, refreshUsers }) => {
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    type: '',
    password: ''
  });
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const userTypes = [
    'cashier', 'delivery', 'captainOrder', 'manager', 'accountant', 'SYSTEMBIGADMIN', 'kitchen'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const newUser = await createNewUser(formData);
      setMessage({ type: 'success', text: '✅ تم إنشاء المستخدم بنجاح' });
      setFormData({ name: '', username: '', type: '', password: '' });

      if (refreshUsers) refreshUsers(newUser);
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("🚫 خطأ أثناء إنشاء المستخدم:", error.message);
      setMessage({ type: 'error', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setMessage(null);

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>إنشاء مستخدم جديد</Typography>
      <form onSubmit={handleSubmit}>
        <TextField label="الاسم" name="name" value={formData.name} onChange={handleChange} fullWidth margin="normal" />
        <TextField label="اسم المستخدم" name="username" value={formData.username} onChange={handleChange} fullWidth margin="normal" />
        <TextField
          label="نوع الحساب"
          name="type"
          value={formData.type}
          onChange={handleChange}
          fullWidth
          margin="normal"
          select
        >
          {userTypes.map((type) => (
            <MenuItem key={type} value={type}>{type}</MenuItem>
          ))}
        </TextField>
        <TextField label="كلمة المرور" name="password" value={formData.password} onChange={handleChange} type="password" fullWidth margin="normal" />
        
        <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading} sx={{ mt: 2 }}>
          {loading ? 'جارٍ الإرسال...' : 'إنشاء المستخدم'}
        </Button>
      </form>

      {message && (
        <Snackbar open autoHideDuration={4000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={message.type} sx={{ width: '100%' }}>
            {message.text}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default CreateUserForm;
